// openRoom — "which room is on screen right now, and is the reader looking at
// it?".
//
// The app-wide alert listener (services/useRoomAlerts.ts) must not ping for a
// message that lands in the room the reader is currently in. RoomChat is the
// only component that knows which room that is, and it mounts far below the
// NotificationProvider — so instead of threading state through the tree (and
// re-rendering the provider on every room switch), RoomChat stamps a module
// global on mount and clears it on unmount. A plain variable, not React state:
// the listener reads it inside a socket callback, never during a render.

let openRoomId: string | null = null;

/** Called by RoomChat on mount / room change (and with null on unmount). */
export function setOpenRoom(roomId: string | null): void {
  openRoomId = roomId || null;
}

export function getOpenRoom(): string | null {
  return openRoomId;
}

/** Is the tab actually in front of the user? Both halves matter: a background
 *  tab is "visible" in some browsers while another window has focus. */
export function tabIsFocused(): boolean {
  if (typeof document === 'undefined') return false;
  if (document.visibilityState !== 'visible') return false;
  return typeof document.hasFocus === 'function' ? document.hasFocus() : true;
}

/** The suppression the alert rules take as `roomOpenAndFocused`. */
export function isRoomOpenAndFocused(roomId: string | null | undefined): boolean {
  if (!roomId) return false;
  return openRoomId === roomId && tabIsFocused();
}
